import { render, staticRenderFns } from "./MyBidsShortList.vue?vue&type=template&id=0818c16e&scoped=true&"
import script from "./MyBidsShortList.vue?vue&type=script&lang=js&"
export * from "./MyBidsShortList.vue?vue&type=script&lang=js&"
import style0 from "./MyBidsShortList.vue?vue&type=style&index=0&id=0818c16e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0818c16e",
  null
  
)

export default component.exports